const pad2 = (n: number) => String(n).padStart(2, '0');

export function formatLocalYmd(d: Date = new Date()) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

/** Shift a YYYY-MM-DD by `days` on the local calendar. */
export function shiftYmd(ymd: string, days: number) {
  const parsed = parseYmd(ymd);
  if (!parsed) return null;
  const [y, m, d] = parsed.split('-').map(Number);
  const date = new Date(y, m - 1, d + days);
  return formatLocalYmd(date);
}

/** Returns YYYY-MM-DD if valid calendar date, else null. */
export function parseYmd(ymd: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  const [y, m, d] = ymd.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  if (
    date.getFullYear() !== y ||
    date.getMonth() !== m - 1 ||
    date.getDate() !== d
  ) {
    return null;
  }
  return ymd;
}

/** True when date is a valid YYYY-MM-DD strictly before local today. */
export function isValidArchiveDate(ymd: string): boolean {
  const parsed = parseYmd(ymd);
  if (!parsed) return false;
  return parsed < formatLocalYmd();
}
